import { createContext } from 'preact';
import { useContext } from 'preact/hooks';
import { BannersConfig } from '../types';

export const ConfigContext = createContext<BannersConfig | null>(null);

export function useConfigContext() {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfigContext must be used within ConfigContext.Provider');
  }
  return context;
}
